export default () => {
  return (
    <svg width="36" height="34" viewBox="0 0 36 34" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0.5 30.25H35.5V33.75H0.5V30.25ZM0.5 5.75L9.25 11L18 0.5L26.75 11L35.5 5.75V26.75H0.5V5.75Z"
            fill="#C75FEA"/>
    </svg>
  )
}